import { 
  collection, addDoc, onSnapshot, query, orderBy, serverTimestamp 
} from 'firebase/firestore';
import { firestore, FIRESTORE_COLECOES } from '../firebase';
import type { MensagemCorridaFirestore } from '../types/firestore';

export interface EnviarMensagemParams {
  remetente_id: string;
  tipo_usuario: 'cliente' | 'operador';
  texto: string;
  imagem_url?: string;
}

/**
 * Enviar mensagem no chat em tempo real vinculado ao ID do pedido
 */
export async function enviarMensagemChat(
  corridaId: string, 
  params: EnviarMensagemParams
): Promise<string> {
  try {
    const colRef = collection(firestore, FIRESTORE_COLECOES.CORRIDAS, corridaId, FIRESTORE_COLECOES.MENSAGENS);
    const docRef = await addDoc(colRef, {
      remetente_id: params.remetente_id,
      tipo_usuario: params.tipo_usuario,
      texto: params.texto,
      imagem_url: params.imagem_url || '',
      enviado_em: serverTimestamp()
    });
    return docRef.id;
  } catch (error) {
    console.error('Erro ao enviar mensagem no chat:', error);
    throw error;
  }
}

/**
 * Escutar mensagens do chat em tempo real
 */
export function escutarMensagensChat(
  corridaId: string, 
  callback: (mensagens: MensagemCorridaFirestore[]) => void
) {
  const colRef = collection(firestore, FIRESTORE_COLECOES.CORRIDAS, corridaId, FIRESTORE_COLECOES.MENSAGENS);
  const q = query(colRef, orderBy('enviado_em', 'asc'));

  return onSnapshot(q, (snapshot) => {
    const msgs = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as MensagemCorridaFirestore[];
    callback(msgs);
  }, (error) => {
    console.error('Erro ao escutar chat em tempo real:', error);
  });
}
